import React, { useEffect, useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import "./addPhaseActions.scss";
import { useDispatch, useSelector } from "react-redux";
import { getNegotiationActions } from "../../../../../redux/Action/Action";
import { RootState } from "../../../../../redux/Reducer";
import CustomCard from "../../../../../components/CustomCard/CustomCard";
import { POST_SAVE_FORM_DETAILS } from "../../../../../redux/Action/actionTypes";

interface CardData {
    id: string;
    title: string;
    description: string;
    relatedPhase: string;
    flag: string;
    actionType: any;
    isTrending: any;
    isMostSelected: any;
    avgRating: any;
    status: boolean;
    preselected: boolean;
    inputText: string;
    isCardSelected?: boolean;
}

interface ModalComponentProps {
    isOpen: boolean;
    toggle: () => void;
    RoundName: string;
    relatedPhase: string;
    fetchUpdatedCards: () => void;
}

const AddPhaseActions = ({
    isOpen,
    toggle,
    RoundName,
    relatedPhase,
    fetchUpdatedCards,
}: ModalComponentProps) => {

    const dispatch = useDispatch();
    const [cardData, setCardData] = useState<CardData[]>([]);
    const [selectedCards, setSelectedCards] = useState<CardData[]>([]);
    const [inputTexts, setInputTexts] = useState<{ [cardId: string]: string }>({});
    const [loading, setLoading] = useState(false);
    const sampleCards = useSelector(
        (state: RootState) => state.negotiationActions.negotiationActions
    );
    const basicDetailsData = useSelector(
        (state: RootState) => state.basicDetails.basicDetailsData
    );
    const powerPositionDetails = useSelector(
        (state: RootState) => state.powerPosition
    );
    const TargetValueData = useSelector(
        (state: RootState) => state.TargetValue.TargetValueData
    );
    const salesRepClassificationData = useSelector(
        (state: RootState) => state.salesRepClassification
    );
    const isFormUpdate = useSelector(
        (state: RootState) => state.basicDetails.formState
    );
    const existingNegotiationActions = useSelector(
        (state: RootState) => state.selectedActionTiles.SelectedActionTilesData
    );
    
    useEffect(() => {
        dispatch(getNegotiationActions());
    }, []);

    useEffect(() => {
        if (sampleCards.length > 0) {
            const filteredCards = sampleCards.filter(
                (item: any) => item.relatedPhase === relatedPhase && item.status === true
            );
            const existing = (existingNegotiationActions as Record<string, any>)[RoundName] || [];
            const existingIds = existing.map((item: any) => item.id);
            const newCards: CardData[] = filteredCards
                .filter((item: any) => !existingIds.includes(item.id))
                .map((item: any) => ({ ...item, inputText: "" }));
            setCardData(newCards);
            const initialInputs: { [cardId: string]: string } = {};
            newCards.forEach((card) => {
                initialInputs[card.id] = "";
            });
            setInputTexts(initialInputs);
        }
    }, [sampleCards, existingNegotiationActions, relatedPhase, RoundName]);

    const handleCardClick = (cardId: string) => {
        const isSelected = selectedCards.some((card) => card.id === cardId);
        if (isSelected) {
            setSelectedCards(selectedCards.filter((card) => card.id !== cardId));
        } else {
            const card = cardData.find((c) => c.id === cardId);
            if (card) {
                const inputText = inputTexts[cardId] || "";
                setSelectedCards([...selectedCards, { ...card, inputText }]);
            }
        }
    };

    const handleInputChange = (cardId: string, value: string) => {
        setSelectedCards((prev) =>
            prev.map((card) => (card.id === cardId ? { ...card, inputText: value } : card))
        );
    };

    const addCardsHandler = () => {
        setLoading(true);
        const existing = (existingNegotiationActions as Record<string, any>)[RoundName] || [];
        const newItems = selectedCards.map((item) => ({
            ...item,
            implementationApproach: item.inputText,
        }));
        const updatedPlan = {
            ...existingNegotiationActions,
            [RoundName]: [...existing, ...newItems],
        };

        dispatch({
            type: POST_SAVE_FORM_DETAILS,
            payload: {
                isFormUpdate,
                basicDetailsData,
                salesRepClassificationData,
                powerPositionDetails,
                TargetValueData,
                PlanNegotiationActions: updatedPlan,
                IsSavedForLater: false,
            },
            meta: {
                onSuccess: () => {
                    setLoading(false);
                    toggle();
                    fetchUpdatedCards();
                    setSelectedCards([]);
                },
                onError: () => {
                    setLoading(false);
                },
            },
        });
    };

    return (
        <div>
            {loading && (
                <div className="loading-overlay">
                    <div className="loading-spinner">Saving actions...</div>
                </div>
            )}
            <Modal isOpen={isOpen} toggle={toggle} modalClassName="negotiation-add-edit-modal">
                <ModalHeader>Add additional actions</ModalHeader>
                <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={toggle}
                    style={{ position: "absolute", top: "10px", right: "10px", zIndex: 10 }}
                ></button>
                {cardData.length > 0 ? (
                    <div>
                        <div className="negoRound-responsive-grid-additional">
                            {cardData.map((card) => (
                                <div key={card.id} onClick={() => handleCardClick(card.id)} className="displayCards">
                                    <CustomCard
                                        id={card.id}
                                        title={card.title}
                                        description={card.description}
                                        flag={card.flag}
                                        actionType={card.actionType}
                                        isTrending={card.isTrending}
                                        isMostSelected={card.isMostSelected}
                                        avgRating={card.avgRating}
                                        inputText={selectedCards.find((obj) => obj.id === card.id)?.inputText || ""}
                                        onInputChange={(value) => handleInputChange(card.id, value)}
                                        isCardSelected={selectedCards.some((obj) => obj.id === card.id)}

                                    />
                                </div>
                            ))}
                        </div>
                        <div className="pop-up-add-cards">
                            <button className="add-cards-button" onClick={addCardsHandler}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                    className="bi bi-plus-lg" style={{ marginRight: "5px" }} viewBox="0 0 15 15">
                                    <path fillRule="evenodd"
                                        d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                </svg>
                                Add selected actions
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="no-cards-message">No additional actions available to add.</div>
                )}
            </Modal>
        </div>
    );

};

export default AddPhaseActions;

